import React from "React"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Layout as AntdLayout, Typography } from "antd"
import "antd/dist/antd.css"

const { Header, Content } = AntdLayout

export default function Layout({ children }) {
  return (
    <StyledLayout>
      <StyledHeader className="header">
        <Link to="/">
          <Logo level={4}>BrandName</Logo>
        </Link>
      </StyledHeader>
      <StyledContent>{children}</StyledContent>
    </StyledLayout>
  )
}

Layout.propTypes = {
  children: PropTypes.node,
}

const StyledLayout = styled(AntdLayout)`
  min-height: 100vh;
  overflow-x: hidden;
`

const StyledHeader = styled(Header)`
  padding: 0 20px;
  @media (min-width: 768px) {
    padding: 0 50px;
  }
`

const StyledContent = styled(Content)`
  padding: 0 20px;
  @media (min-width: 768px) {
    padding: 0 50px;
  }
`

const Logo = styled(Typography)`
  color: #fff;
`
